import { useRef, useState } from 'react';

import { Helmet } from 'react-helmet';

import { useLocation, useNavigate } from 'react-router-dom';

import {

  Button, Col, Form, FormControl, FormLabel, Row, Spinner, InputGroup,

} from 'react-bootstrap';

import StatusAlert from '../components/StatusAlert';

import useAuth from '../hooks/useAuth';

import useForm from '../hooks/useForm';




import './auth.css';




function redirectPath(search) {

  const match = search.match(/redirect=(.*)/);

  const redirect = match?.[1];

  return redirect ? decodeURIComponent(redirect) : '/admin';

}




function AdminLogin() {

  const title = 'Admin Login';

  const [isLoading, setIsLoading] = useState(false);

  const [passwordVisible, setPasswordVisible] = useState(false);

  const { adminLogin } = useAuth();

  const navigate = useNavigate();

  const { search } = useLocation();

  const alertOpts = useRef({ isShow: false, message: '' });

  const handleDismiss = () => {

    alertOpts.current.isShow = false;

  };




  const handleLogin = async (e, data) => {

    try {

      setIsLoading(true);

      const token = await adminLogin(data.username, data.password);

      console.log(`login successful, token: ${token}`);

      setIsLoading(false);

      navigate(redirectPath(search));

    } catch (err) {

      alertOpts.current = { isShow: true, message: err.message };

      setIsLoading(false);

    }

  };




  const validators = {

    username: {

      required: {

        value: true,

        message: 'username is required',

      },

    },

    password: {

      required: {

        value: true,

        message: 'password is required',

      },

    },

  };




  const {

    data, handleChange, handleSubmit, errors,

  } = useForm({

    onSubmit: handleLogin,

    validators,

  });




  return (

    <>

      <Helmet>

        <title>{title}</title>

      </Helmet>

      <div className="container-fluid mb-5 px-3">
        <div className="row mx-auto align-content-center" style={{ maxWidth: "30rem", minHeight: "70vh" }}>
          <div className="card card-lg bg-white p-4" >
            <div className="card-body">

              <Form noValidate>

                <h4 className="text-secondary">Admin Account Login</h4>

                <p className="mb-3 fw-normal no-wrap">

                  Click <strong>Log in</strong> to log into admin dashboard.

                </p>

                <Form.Group className="form-floating" controlId="inputUsername">

                  <FormControl type="text"

                    className="form-control form-input-top mb-3"

                    isInvalid={errors?.username}

                    placeholder="Username"

                    onChange={handleChange('username')}

                  />

                  <FormLabel>Username</FormLabel>

                </Form.Group>

                <Form.Group className="form-floating" controlId="inputPassword">

                  <InputGroup>

                    <FormControl type={passwordVisible ? "text" : "password"}

                      className="form-control form-input-bottom mb-3"

                      isInvalid={errors?.password}

                      placeholder="Password"

                      onChange={handleChange('password')}

                    />

                    <FormLabel>Password</FormLabel>

                    <Button variant="outline-link" onClick={() => setPasswordVisible(!passwordVisible)}>

                      <i className={`bi ${passwordVisible ? 'bi-eye-slash' : 'bi-eye'}`}></i>

                    </Button>

                  </InputGroup>

                </Form.Group>

                <div>

                  {Object.keys(errors).map((key) => <div className="text-danger" key={key}>{errors[key]}</div>)}

                </div>

                <Form.Group as={Row} className="my-3" controlId="isRemember">

                  <Col sm={{ span: 8, offset: 3 }} className="text-md-start">

                    {/* <Form.Check label="Remember me"

                checked={data.isRemember}

                onChange={handleChange('isRemember')} /> */}

                  </Col>

                </Form.Group>

                <Button className="w-100 btn btn-lg btn-primary"

                  type="button"

                  disabled={isLoading}

                  onClick={handleSubmit}

                >

                  <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" hidden={!isLoading} />

                  <span className="px-2">Log in</span>

                </Button>

              </Form>

            </div>
          </div>
        </div>
      </div>

      <StatusAlert show={alertOpts.current.isShow}

        variant="failure"

        message={alertOpts.current.message}

        onDismiss={handleDismiss}

      />

    </>

  );

}




export default AdminLogin;
